import { MenuItemType } from '../@types';
import { ODDS_FORMAT } from '../types/enums';

export const ODDS_FORMAT_OPTIONS: MenuItemType[] = Object.entries(ODDS_FORMAT).map(([key, value]) => ({
  key,
  label: value.toLocaleLowerCase(),
}));
